import utils from '@common/utils';

const fullMenus = [
  {
    title: '结算清单核查',
    key: 'MaterialCheck',
    icon: 'icon-paper'
  },
  {
    title: '结算清单处理',
    key: 'SettlementProcess',
    icon: 'icon-paper-stack'
  },
  {
    title: '物资导入模板',
    key: 'InventoryImport',
    icon: 'icon-box'
  },
  {
    title: 'CIi3成本分析',
    key: 'Cji3CostAnalysis',
    icon: 'icon-bar-graph-2'
  },
  {
    title: '二维码解析',
    key: 'QrcodeParse',
    icon: 'icon-qrcode'
  },
  {
    title: 'Excel表格拆分',
    key: 'ExcelSplit',
    icon: 'icon-grid-2'
  },
  {
    title: '文件传输',
    key: 'FileTransfer',
    icon: 'icon-share'
  },
  {
    title: 'Icons',
    key: 'Icons',
    icon: 'icon-heart'
  },
  {
    title: '列表应用',
    key: 'TableList',
    icon: 'icon-grid-2',
    children: [
      {
        title: '基础表格',
        key: 'TableBasic'
      },
      {
        title: '查询列表',
        key: 'TableSearch'
      }
    ]
  },
  {
    title: '表单应用',
    key: 'FormFolder',
    icon: 'icon-paper',
    children: [
      {
        title: '基础表单',
        key: 'Form'
      },
      {
        title: '表单详情',
        key: 'FormDetail'
      }
    ]
  },
  {
    title: '模糊匹配',
    key: 'AutoCompleteFolder',
    icon: 'icon-disc',
    children: [
      {
        title: '模糊搜索',
        key: 'Autocomplete1'
      },
      {
        title: '场景应用',
        key: 'Autocomplete2'
      },
      {
        title: '复杂场景',
        key: 'Autocomplete3'
      }
    ]
  },
  {
    title: '扩展组件',
    key: 'Advance-folder',
    icon: 'icon-bar-graph-2',
    children: [
      {
        title: '图表',
        key: 'Chart'
      },
      {
        title: '富文本编辑器',
        key: 'RicktextEditor'
      },
      {
        title: '代码编辑器',
        key: 'CodeEditor'
      },
      {
        title: 'Markdown编辑器',
        key: 'MarkdownEditor'
      },
      {
        title: '百度地图',
        key: 'BaiduMap'
      }
    ]
  },
  {
    title: '系统设置',
    key: 'SysSetting',
    icon: 'icon-cog',
    children: [
      {
        title: '用户管理',
        key: 'Users'
      },
      {
        title: '访问日志',
        key: 'AccessLog'
      },
      {
        title: '个人中心',
        key: 'AccountBasic'
      },
      {
        title: '权限设置',
        key: 'Authorization'
      }
    ]
  },
  {
    title: '错误页面',
    key: 'ErrorPages',
    icon: 'icon-ban',
    children: [
      {
        title: '系统错误',
        key: 'SystemError'
      },
      {
        title: '权限错误',
        key: 'PermissionError'
      },
      {
        title: '找不到页面',
        key: 'NotfoundError'
      }
    ]
  }
];

const getMenus = function (menuIdList = []) {
  return getAuthMenu(fullMenus, menuIdList);
};

let getAuthMenu = (menus, menuIdList) => {
  let configMenu = [];
  for (let menu of menus) {
    let m = utils.copy(menu);
    if (menu.children && menu.children.length) {
      m.children = getAuthMenu(menu.children, menuIdList);
      if (m.children.length > 0 || menuIdList.indexOf(m.key) > -1) {
        configMenu.push(m);
      }
    } else if (menuIdList.indexOf(m.key) > -1) {
      configMenu.push(m);
    }
  }
  return configMenu;
};

const getKeys = function (menus) {
  let keys = [];
  for (let menu of menus) {
    keys.push(menu.key);
    if (menu.children && menu.children.length) {
      keys.push(...getKeys(menu.children));
    }
  }
  return keys;
};

let fullMenuKeys = getKeys(fullMenus);

/** 按 fullMenus 顺序过滤后端返回的菜单 key，不自动补全未授权项 */
const filterMenuKeys = function (keys) {
  if (!Array.isArray(keys) || !keys.length) {
    return [];
  }
  const keySet = new Set(keys);
  return fullMenuKeys.filter((key) => keySet.has(key));
};

/** 仅保留仍有效的菜单 key，绝不自动补回未授权项 */
const resolveMenuKeys = function (storedKeys) {
  return filterMenuKeys(Array.isArray(storedKeys) ? storedKeys : []);
};

const AUTH_PAGE_ALIAS = {
  SettlementArchiveDetail: 'SettlementArchive'
};

const isAuthPage = function (menus, name) {
  const authName = AUTH_PAGE_ALIAS[name] || name;
  if (fullMenuKeys.indexOf(authName) > -1 && menus.indexOf(authName) == -1) {
    return false;
  }
  return true;
};

const menuKeysEqual = function (left, right) {
  if (!Array.isArray(left) || !Array.isArray(right)) {
    return false;
  }
  if (left.length !== right.length) {
    return false;
  }
  for (let i = 0; i < left.length; i++) {
    if (left[i] !== right[i]) {
      return false;
    }
  }
  return true;
};

export { getMenus, fullMenus, fullMenuKeys, filterMenuKeys, resolveMenuKeys, menuKeysEqual, isAuthPage };
